class KillIEPlz {
	constructor() {

		if(isIE){
			if(localStorage.getItem('killieplz') !== 'true'){
				$('.please-dont-use-internet-explorer').show();
				$('.please-dont-use-internet-explorer .close-button').on('click', function () {
					$('.please-dont-use-internet-explorer').fadeOut();
				});
				localStorage.setItem('killieplz', 'true');
			}
		}
	}

}